import styled from 'styled-components';

export const PageStyled = styled.div`
    .expedition-information {
        display: flex;
        justify-content: flex-start;
        width: fit-content;
        flex-direction: row;
        align-items: center;
        gap: 8px;
        line-height: 0;
        .icon-box {
            background-color: #f0f4f9;
            border-radius: 4px;
            padding: 3px;
            color: #646a76;
            .material-icons,
            .app-icon {
                font-size: 14px;
                width: 14px;
                height: 14px;
            }
            &:hover {
                .material-icons,
                .app-icon {
                    color: var(--mui-palette-primary-main);
                }
            }
        }
    }
`;
